
import {Component, Prop, Vue} from 'vue-property-decorator';
import {commitAddNotification} from '@/store/main/mutations';
import {IPermission} from '@/interfaces/permission';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';
import {IForm} from '@/interfaces/form';

@Component({
    components: {VuePerfectScrollbar},
})
export default class ShowFormsialog extends Vue {
  @Prop()
  public objData!: any;

  private dialog: boolean = false;

  get scrollSettings() {
    return {
      maxScrollbarLength: 120,
    };
  }

  get items(): (IForm)[] {
    return this.objData?.forms || [];
  }

  get permissionOwner(): string {
    return this.objData?.name || this.objData?.fullname;
  }
}
